import React from "react";
import { useTheme, Flex, FlexProps } from "../../";

export type ContainerProps = FlexProps;

export const Container: React.FC<ContainerProps> = (styledProps) => {
  const theme = useTheme();

  return (
    <Flex
      maxWidth={theme.maxWidths.cotdWebsite}
      mx="auto"
      my="0"
      {...styledProps}
    ></Flex>
  );
};

Container.displayName = "Container";

export default Container;
